import { apiRequest } from './api';
import { t, uiLanguage } from './language';

/**
 * Skribby toplantı botu. Skribby anahtarı masaüstünde yok: bot oluşturma ve
 * durdurma TalkNote sunucusu üzerinden (`/api/v1/bots`). Botun durumunu izleyip
 * biten toplantıyı tamamlayan da sunucu (web/lib/jobs/bots.ts).
 */

export type SkribbyService = 'gmeet' | 'zoom' | 'teams';

export interface SkribbyBot {
  id: string;
  status: string;
  stop_reason?: string | null;
  recording_url?: string | null;
  transcript?: unknown;
  participants?: unknown;
  created_at?: string;
  finished_at?: string | null;
  /** Sunucunun bu botta kullandığı transkript modeli; "none" = yalnızca kayıt. */
  transcription_model?: string;
}

/** Toplantı linkinden platformu çıkarır; desteklenmiyorsa null. */
export function detectService(meetingUrl: string): SkribbyService | null {
  let host: string;
  try {
    host = new URL(meetingUrl).hostname.toLowerCase();
  } catch {
    return null;
  }
  if (host === 'meet.google.com') return 'gmeet';
  if (host === 'zoom.us' || host.endsWith('.zoom.us')) return 'zoom';
  if (host === 'teams.microsoft.com' || host === 'teams.live.com' || host.endsWith('.teams.microsoft.com')) {
    return 'teams';
  }
  return null;
}

export interface CreateBotInput {
  meetingUrl: string;
  service: SkribbyService;
  /** Gelecekteki bir başlangıç — verilirse bot o saatte katılır. */
  scheduledStart?: Date;
  metadata: Record<string, string>;
}

export async function createBot(input: CreateBotInput): Promise<SkribbyBot> {
  const meetingId = input.metadata.meeting_id;
  if (!meetingId) throw new Error(t('Bot için toplantı kimliği yok.', 'No meeting id for the bot.'));
  const { bot } = await apiRequest<{ bot: SkribbyBot }>('POST', '/api/v1/bots', {
    body: {
      meetingId,
      meetingUrl: input.meetingUrl,
      scheduledStart: input.scheduledStart?.toISOString(),
      // Botun toplantıda görünen adı arayüz dilinde.
      language: uiLanguage(),
    },
    timeoutMs: 45_000,
  });
  return bot;
}

export async function stopBot(botId: string): Promise<void> {
  await apiRequest('POST', `/api/v1/bots/${encodeURIComponent(botId)}/stop`, { timeoutMs: 45_000 });
}
